/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return RecommendationBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationBase>): RecommendationBase {
        let obj = Object.assign(new RecommendationBase(), model);
        RecommendationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationBase>): RecommendationBase {
        if (!model) return null;
        return RecommendationBase.newInstance(<RecommendationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationBase) {
        if (!obj) return;

        models.RecommendationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationBase): boolean {
        switch (obj.__type)
        {
            case "DescriptorForRecommendation":
                Object.setPrototypeOf(obj, models.DescriptorForRecommendation.prototype);
                break;
            case "RecommendationBaseForFinOps":
                Object.setPrototypeOf(obj, models.RecommendationBaseForFinOps.prototype);
                break;
            case "RecommendationBaseForFinopsCustomResource":
                Object.setPrototypeOf(obj, models.RecommendationBaseForFinopsCustomResource.prototype);
                break;
            case "RecommendationForFinopsAnomalySystem":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsAnomalySystem.prototype);
                break;
            case "RecommendationForFinopsBillingAzureAdvisor":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsBillingAzureAdvisor.prototype);
                break;
            case "RecommendationForFinopsBudgetSystem":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsBudgetSystem.prototype);
                break;
            case "RecommendationForFinopsConfigAHBResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigAHBResource.prototype);
                break;
            case "RecommendationForFinopsConfigAwsAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigAwsAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsConfigAzureAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigAzureAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsConfigGcpAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigGcpAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsConfigOciAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigOciAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsConfigSystemResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsConfigSystemResource.prototype);
                break;
            case "RecommendationForFinopsCustomBillingResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsCustomBillingResource.prototype);
                break;
            case "RecommendationForFinopsCustomConfigResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsCustomConfigResource.prototype);
                break;
            case "RecommendationForFinopsCustomIdleResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsCustomIdleResource.prototype);
                break;
            case "RecommendationForFinopsCustomOrphanedResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsCustomOrphanedResource.prototype);
                break;
            case "RecommendationForFinopsCustomUnderUtilizedResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsCustomUnderUtilizedResource.prototype);
                break;
            case "RecommendationForFinopsGovernanceSystem":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsGovernanceSystem.prototype);
                break;
            case "RecommendationForFinopsIdleAwsAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsIdleAwsAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsIdleAzureAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsIdleAzureAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsIdleGcpAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsIdleGcpAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsIdleOciAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsIdleOciAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsIdleSystemResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsIdleSystemResource.prototype);
                break;
            case "RecommendationForFinopsOptimizedAwsAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOptimizedAwsAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsOptimizesAzureAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOptimizesAzureAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsOrphanedAwsAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOrphanedAwsAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsOrphanedGcpAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOrphanedGcpAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsOrphanedOciAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOrphanedOciAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsOrphanedSystemResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsOrphanedSystemResource.prototype);
                break;
            case "RecommendationForFinopsScheduleRecommendationResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsScheduleRecommendationResource.prototype);
                break;
            case "RecommendationForFinopsTagsSystem":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsTagsSystem.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedAzureAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedAzureAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedOciAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedOciAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsUnderUtilizedSystemResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderUtilizedSystemResource.prototype);
                break;
            case "RecommendationForFinopsUnderutilizedCorestackProfilerResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderutilizedCorestackProfilerResource.prototype);
                break;
            case "RecommendationForFinopsUnderutilizedGcpAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUnderutilizedGcpAdvisorResource.prototype);
                break;
            case "RecommendationForFinopsUtilizationAzureAdvisorResource":
                Object.setPrototypeOf(obj, models.RecommendationForFinopsUtilizationAzureAdvisorResource.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof RecommendationBase)[] {
        return [
            models.DescriptorForRecommendation,
            models.RecommendationBaseForFinOps,
            models.RecommendationBaseForFinopsCustomResource,
            models.RecommendationForFinopsAnomalySystem,
            models.RecommendationForFinopsBillingAzureAdvisor,
            models.RecommendationForFinopsBudgetSystem,
            models.RecommendationForFinopsConfigAHBResource,
            models.RecommendationForFinopsConfigAwsAdvisorResource,
            models.RecommendationForFinopsConfigAzureAdvisorResource,
            models.RecommendationForFinopsConfigGcpAdvisorResource,
            models.RecommendationForFinopsConfigOciAdvisorResource,
            models.RecommendationForFinopsConfigSystemResource,
            models.RecommendationForFinopsCustomBillingResource,
            models.RecommendationForFinopsCustomConfigResource,
            models.RecommendationForFinopsCustomIdleResource,
            models.RecommendationForFinopsCustomOrphanedResource,
            models.RecommendationForFinopsCustomUnderUtilizedResource,
            models.RecommendationForFinopsGovernanceSystem,
            models.RecommendationForFinopsIdleAwsAdvisorResource,
            models.RecommendationForFinopsIdleAzureAdvisorResource,
            models.RecommendationForFinopsIdleGcpAdvisorResource,
            models.RecommendationForFinopsIdleOciAdvisorResource,
            models.RecommendationForFinopsIdleSystemResource,
            models.RecommendationForFinopsOptimizedAwsAdvisorResource,
            models.RecommendationForFinopsOptimizesAzureAdvisorResource,
            models.RecommendationForFinopsOrphanedAwsAdvisorResource,
            models.RecommendationForFinopsOrphanedGcpAdvisorResource,
            models.RecommendationForFinopsOrphanedOciAdvisorResource,
            models.RecommendationForFinopsOrphanedSystemResource,
            models.RecommendationForFinopsScheduleRecommendationResource,
            models.RecommendationForFinopsTagsSystem,
            models.RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource,
            models.RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource,
            models.RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource,
            models.RecommendationForFinopsUnderUtilizedAzureAdvisorResource,
            models.RecommendationForFinopsUnderUtilizedOciAdvisorResource,
            models.RecommendationForFinopsUnderUtilizedSystemResource,
            models.RecommendationForFinopsUnderutilizedCorestackProfilerResource,
            models.RecommendationForFinopsUnderutilizedGcpAdvisorResource,
            models.RecommendationForFinopsUtilizationAzureAdvisorResource,
        ];
    }

    fixupFields() {
    }

}
